var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tabs',{attrs:{"background-color":"white","color":"primary","show-arrows":""}},[_c('v-tabs-slider',{attrs:{"color":"primary"}}),_vm._l((_vm.visibleTabs),function(tab,index){return _c('v-tab',{key:index,attrs:{"to":{
      name: tab.routeName,
    }},domProps:{"textContent":_vm._s(tab.name)}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }